import React from 'react'
import { Link } from 'react-router-dom';
import Team_Three from '../../../assets/images/team/team-three-1.png';
import Team_ThreeTwo from '../../../assets/images/team/team-three-2.png';
import Team_Threethree from '../../../assets/images/team/team-three-3.png';
import Team_02 from '../../../assets/images/svg/header/Twiter.svg';
import Team_03 from '../../../assets/images/svg/header/Insta.svg';


const Team = () => {
    return (
        <>
            <div className="team-section-three">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-5 m-auto">
                            <div className="heading-box text-center">
                                <h2
                                    className="heading-title animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                >
                                    Most Creative People Around Us
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row gutter-y-30">
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="team-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="team-image-three">
                                    <img src={Team_Three} alt="team-image" />
                                </div>
                                <h4>
                                    <Link to="/Team">Sarah Charlotte</Link>
                                </h4>
                                <p>Chef Advisor</p>
                                <ul className="team-social-media-three">
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={Team_02} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={Team_03} alt="icon" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div >
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="team-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="team-image-three">
                                    <img src={Team_ThreeTwo} alt="team-image" />
                                </div>
                                <h4>
                                    <Link to="/Team">Richard Divas</Link>
                                </h4>
                                <p>Chef Advisor</p>
                                <ul className="team-social-media-three">
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={Team_02} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={Team_03} alt="icon" />
                                        </Link>
                                    </li >
                                </ul >
                            </div >
                        </div >
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="team-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="team-image-three">
                                    <img src={Team_Threethree} alt="team-image" />
                                </div>
                                <h4>
                                    <Link to="/Team">Monalis</Link>
                                </h4>
                                <p>Chef Advisor</p>
                                <ul className="team-social-media-three">
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={Team_02} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={Team_03} alt="icon" />
                                        </Link>
                                    </li >
                                </ul >
                            </div >
                        </div >
                        <div className="col-lg-3 col-md-6">
                            <div
                                className="team-box-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="800ms"
                            >
                                <div className="team-image-three">
                                    <img src={Team_Threethree} alt="team-image" />
                                </div>
                                <h4>
                                    <Link to="/Team">Hendry David</Link>
                                </h4>
                                <p>Chef Advisor</p>
                                <ul className="team-social-media-three">
                                    <li>
                                        <Link to="https://www.facebook.com/">
                                            <i className="fa-brands fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://x.com/">
                                            <img src={Team_02} alt="icon" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.instagram.com/">
                                            <img src={Team_03} alt="icon" />
                                        </Link>
                                    </li >
                                </ul >
                            </div >
                        </div >
                    </div >
                </div >
            </div >

        </>
    )
}

export default Team
